/*
  API's used in this file
  1. listStudentPackages or listUserPackages
  2. listUserQuizzesByUserPackageId
*/

import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import Moment from 'react-moment';
import { Button } from 'react-bootstrap';
import { Images, ReactTable } from '../../components';
import { useNavigate } from 'react-router-dom';
import WithNavBar from '../../Layouts/WithNavBar';
import StudentTopbar from '../../components/StudentTopbar';
import StudentMenu from '../../components/StudentMenu';
import './style.sass';
import { toast } from 'react-toastify';
import CustomFooter from '../../components/CustomFooter';
import * as TYPES from '../../store/actions/actions.js';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import {
  getUserQuiz,
  getPracticeSummary,
  listQuizzesByUserId,
  listUserQuizzesByUserId,
  listUserQuizzesByUserPackageId,
} from '../../api/queries';
import { createUserQuiz, ensurePracticeSession } from '../../api/mutations';
// import { FaBell } from 'react-icons/fa';

const DIAGNOSTIC_TYPES = ['Diagnostic', 'Diagonostic'];

function MyCourses() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const hasBootstrappedAuthRef = useRef(false);
  const [allTransactions, setAllTransactions] = useState([]);
  const [myCourses, setMyCourses] = useState([]);
  const [diagnosticCourses, setDiagnosticCourses] = useState([]);
  const [practiceQuizzes, setPracticeQuizzes] = useState([]);
  const [pendingPracticeUserQuiz, setPendingPracticeUserQuiz] = useState(null);
  const [practiceSummary, setPracticeSummary] = useState(null);
  const [user, setUser] = useState({});
  const [tableData, setTableData] = useState([]);
  const [diagnosticTableData, setDiagnosticTableData] = useState([]);
  const [practiceTableData, setPracticeTableData] = useState([]);
  const [activeTab, setActiveTab] = useState('courses');
  const [pendingDiagnosticPackageIds, setPendingDiagnosticPackageIds] = useState([]);
  const columns = React.useMemo(() => [
    {
      Header: '',
      accessor: 'image',
      disableSortBy: true,
    },
    {
      Header: 'Course Name',
      accessor: 'name',
    },
    {
      Header: 'Enrolled Student',
      accessor: 'student',
    },
    {
      Header: 'Last Activity',
      accessor: 'activity',
    },
    {
      Header: 'Licensed Until',
      accessor: 'license',
    },
  ]);

  const practiceColumns = React.useMemo(() => [
    {
      Header: 'Practice',
      accessor: 'name',
    },
    {
      Header: 'Generated At',
      accessor: 'createdAt',
    },
    {
      Header: '',
      accessor: 'action',
      disableSortBy: true,
    },
  ]);

  const [currentUser, courses, userTemp] = useSelector((state) => {
    return [state.auth.cognito, state.courses.myCourses, state.auth.user];
  });

  const onAddCourse = () => {
    navigate('/courses');
  };

  const onClickCourse = (id) => {
    dispatch(Actions.dispatchListUserQuizzesByUserPackageId({ id })).then(() => {
      navigate('/quizzes');
    });
  };

  const onResumePractice = async (userQuizId, practiceQuizId) => {
    try {
      const userQuizRes = await API.graphql(
        graphqlOperation(getUserQuiz, {
          id: userQuizId,
        }),
      );
      const fullUserQuiz = userQuizRes?.data?.getUserQuiz;
      if (!fullUserQuiz?.id) {
        toast.error('Unable to load practice data');
        return;
      }

      dispatch(Actions.saveSelectedQuizIdForSections(practiceQuizId));
      dispatch(Actions.saveSelectedQuiz(fullUserQuiz));
      navigate('/start_test');
    } catch (e) {
      toast.error('Unable to resume practice');
    }
  };

  const onStartPractice = async (practiceConfig) => {
    try {
      let practiceQuizId = practiceConfig?.id || null;
      let createdUserQuizId = null;

      if (practiceConfig?.sourceUserQuizId) {
        const ensureRes = await API.graphql(
          graphqlOperation(ensurePracticeSession, {
            sourceUserQuizId: practiceConfig.sourceUserQuizId,
          }),
        );
        const ensured = JSON.parse(ensureRes?.data?.ensurePracticeSession || '{}');
        if (ensured?.statusCode !== 200) {
          const msg =
            ensured?.body?.message || ensured?.message || 'Unable to start practice';
          toast.error(msg);
          return;
        }
        practiceQuizId = ensured?.body?.data?.practiceQuizId || practiceQuizId;
        createdUserQuizId = ensured?.body?.data?.practiceUserQuizId || null;
      } else {
        const createRes = await API.graphql(
          graphqlOperation(createUserQuiz, {
            userId: currentUser.username,
            quizId: practiceConfig.id,
          }),
        );
        const parsed = JSON.parse(createRes?.data?.createUserQuiz || '{}');
        if (parsed?.statusCode !== 200) {
          const msg = parsed?.body?.message || parsed?.message || 'Unable to start practice';
          toast.error(msg);
          return;
        }
        createdUserQuizId = parsed?.body?.data?.id;
        practiceQuizId = practiceConfig.id;
      }

      if (!createdUserQuizId || !practiceQuizId) {
        toast.error('Unable to start practice');
        return;
      }

      const userQuizRes = await API.graphql(
        graphqlOperation(getUserQuiz, {
          id: createdUserQuizId,
        }),
      );
      const fullUserQuiz = userQuizRes?.data?.getUserQuiz;
      if (!fullUserQuiz?.id) {
        toast.error('Unable to load practice data');
        return;
      }

      dispatch(Actions.saveSelectedQuizIdForSections(practiceQuizId));
      dispatch(Actions.saveSelectedQuiz(fullUserQuiz));
      navigate('/start_test');
    } catch (e) {
      toast.error('Unable to start practice');
    }
  };

  useEffect(() => {
    dispatch({
      type: TYPES.LOADER_TEXT,
      data: '',
    });
    if (!currentUser) {
      if (hasBootstrappedAuthRef.current) return;
      hasBootstrappedAuthRef.current = true;

      (async () => {
        try {
          let userInfo = await Auth.currentUserInfo();
          if (!userInfo?.attributes?.email) {
            await Auth.currentAuthenticatedUser({ bypassCache: true });
            userInfo = await Auth.currentUserInfo();
          }
          if (!userInfo?.attributes) return;

          const userAttributes = userInfo.attributes || {};
          const resolvedUsername =
            userAttributes.username || userInfo.username || userAttributes.sub;
          userAttributes.username = resolvedUsername;

          dispatch(Actions.submitLoginUser(userAttributes));
        } catch (e) {}
      })();

      return;
    }

    (async () => {
      const isCheckoutReturn = window?.location?.href?.includes('checkoutId=');

      if (isCheckoutReturn) {
        toast.success("We've confirmed your payment. Thank you for registration");
      }

      if (currentUser.profile === 'STUDENT') {
        dispatch(
          Actions.dispatchMyCousesForStudent({
            studentId: currentUser.username,
            sortDirection: 'DESC',
          }),
        );
      } else {
        dispatch(
          Actions.dispatchMyCousesForParent({
            userId: currentUser.username,
            sortDirection: 'DESC',
          }),
        );
      }

      try {
        try {
          const practiceSummaryRes = await API.graphql(
            graphqlOperation(getPracticeSummary, {
              userId: currentUser.username,
            }),
          );
          const parsedSummary = JSON.parse(
            practiceSummaryRes?.data?.getPracticeSummary || '{}',
          );
          setPracticeSummary(parsedSummary?.body?.data || null);
        } catch (e) {
          setPracticeSummary(null);
        }

        try {
          const unfinishedUserQuizzesRes = await API.graphql(
            graphqlOperation(listUserQuizzesByUserId, {
              userId: currentUser.username,
              sortDirection: 'DESC',
              filter: { status: { ne: 'FINISHED' } },
              limit: 50,
            }),
          );
          const unfinishedItems =
            unfinishedUserQuizzesRes?.data?.listUserQuizzesByUserId?.items || [];
          const practicePending = unfinishedItems.find(
            (uq) =>
              uq?.status &&
              uq.status !== 'FINISHED' &&
              uq?.quiz?.type === 'Practice' &&
              uq?.id &&
              uq?.quizId,
          );
          setPendingPracticeUserQuiz(practicePending || null);
        } catch (e) {
          setPendingPracticeUserQuiz(null);
        }

        const practiceResult = await API.graphql(
          graphqlOperation(listQuizzesByUserId, {
            userId: currentUser.username,
            sortDirection: 'DESC',
            filter: { type: { eq: 'Practice' } },
            limit: 100,
          }),
        );
        const practiceItems = practiceResult?.data?.listQuizzesByUserId?.items || [];

        const filtered = practiceItems.filter((q) => q?.type === 'Practice');

        const buildPracticeRows = (quizList) => {
          return quizList.map((q) => {
            const rowKey = q?.id;
            return {
              name: (
                <div className="table-rows" key={rowKey}>
                  <span className="active">{q?.title}</span>
                </div>
              ),
              createdAt: (
                <div className="table-rows" key={rowKey}>
                  <Moment format="MMM DD, YYYY">{q?.createdAt}</Moment>
                </div>
              ),
              action: (
                <div className="table-rows" key={rowKey}>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => onStartPractice(q)}
                  >
                    Start
                  </Button>
                </div>
              ),
            };
          });
        };

        const finalPracticeQuizzes = filtered;
        setPracticeQuizzes(finalPracticeQuizzes);
        setPracticeTableData(buildPracticeRows(finalPracticeQuizzes));
      } catch (e) {
        setPracticeQuizzes([]);
        setPracticeTableData([]);
      }

      if (isCheckoutReturn) {
        setTimeout(() => {
          navigate('/my-courses');
          window?.location?.reload();
        }, 5000);
      }
    })();
  }, [currentUser]);

  useEffect(() => {
    if (courses) {
      const nonDiagnostic = [];
      const diagnostic = [];

      courses.forEach((singleCourse) => {
        if (DIAGNOSTIC_TYPES.includes(singleCourse?.package?.type)) {
          diagnostic.push(singleCourse);
        } else {
          nonDiagnostic.push(singleCourse);
        }
      });

      const buildRows = (courseList) => {
        return courseList.map((singleCourse) => {
          const rowKey = singleCourse?.id;
          return {
            image: (
              <div className="table-rows" key={rowKey}>
                <img className="cart-course-img" src={singleCourse?.package?.image} />
              </div>
            ),
            name: (
              <div className="table-rows" key={rowKey}>
                <a
                  href="#"
                  className="text-decoration-none"
                  onClick={() => onClickCourse(singleCourse?.id)}
                >
                  <span className="active text-decoration-underline">
                    {singleCourse?.package?.alias
                      ? singleCourse?.package?.alias
                      : singleCourse?.package?.title}
                  </span>
                </a>
              </div>
            ),
            student: (
              <div className="table-rows" key={rowKey}>
                <span className="">
                  {singleCourse?.student?.firstName} {singleCourse?.student?.lastName}
                </span>
              </div>
            ),
            activity: (
              <div className="table-rows" key={rowKey}>
                <Moment format="MMM DD, YYYY" add={singleCourse?.duration}>
                  {singleCourse?.updatedAt}
                </Moment>
              </div>
            ),
            license: (
              <div className="table-rows" key={rowKey}>
                <Moment format="MMM DD, YYYY" add={singleCourse?.duration}>
                  {singleCourse?.expiresAt}
                </Moment>
              </div>
            ),
          };
        });
      };

      setMyCourses(nonDiagnostic);
      setDiagnosticCourses(diagnostic);
      setTableData(buildRows(nonDiagnostic));
      setDiagnosticTableData(buildRows(diagnostic));
    }
  }, [courses]);

  useEffect(() => {
    if (!diagnosticCourses?.length) {
      setPendingDiagnosticPackageIds([]);
      return;
    }

    (async () => {
      try {
        const pendingIds = [];
        for (const diagnosticUserPackage of diagnosticCourses) {
          const result = await API.graphql(
            graphqlOperation(listUserQuizzesByUserPackageId, {
              userPackageId: diagnosticUserPackage.id,
              filter: {
                status: { ne: 'FINISHED' },
              },
              limit: 50,
              sortDirection: 'DESC',
            }),
          );
          const items = result?.data?.listUserQuizzesByUserPackageId?.items || [];
          const hasPending = items.some((item) => item?.status && item.status !== 'FINISHED');
          if (hasPending) {
            pendingIds.push(diagnosticUserPackage.id);
          }
        }

        setPendingDiagnosticPackageIds(pendingIds);
      } catch (err) {
        console.log('Error in checking pending Diagnostic quizzes is ', err);
        setPendingDiagnosticPackageIds([]);
      }
    })();
  }, [diagnosticCourses]);

  useEffect(() => {
    if (userTemp) {
      setUser(userTemp);
    }
  }, [userTemp]);

  // 没有 Diagnostic 内容时，不显示该 tab，并回到 My Courses
  useEffect(() => {
    if (!diagnosticCourses?.length && activeTab === 'diagnostic') {
      setActiveTab('courses');
    }
  }, [diagnosticCourses, activeTab]);

  return (
    <WithNavBar IsLoggedIn={true}>
      <div className={'container courses-view pb-3'}>
        <StudentTopbar name={'John'} />
        <StudentMenu
          active={'courses'}
          rightContent={
            <div className="mycourses-tabs">
              <button
                type="button"
                className={activeTab === 'courses' ? 'tab active' : 'tab'}
                onClick={() => setActiveTab('courses')}
              >
                My Courses
              </button>
              {diagnosticCourses?.length ? (
                <button
                  type="button"
                  className={activeTab === 'diagnostic' ? 'tab active' : 'tab'}
                  onClick={() => setActiveTab('diagnostic')}
                >
                  Diagnostic
                </button>
              ) : null}
              {(practiceQuizzes?.length || pendingPracticeUserQuiz?.id) ? (
                <button
                  type="button"
                  className={activeTab === 'practice' ? 'tab active' : 'tab'}
                  onClick={() => setActiveTab('practice')}
                >
                  Practice
                </button>
              ) : null}
            </div>
          }
        />
        <div className={'heading'}>
          <div className={'start-item'}>
            <span>My Courses</span>
            <Button className={'add-course'} onClick={onAddCourse}>
              + Add a course
            </Button>
          </div>
        </div>

        <div className="practice-summary-card">
          <div className="practice-summary-card__content">
            <div className="practice-summary-card__eyebrow">Today</div>
            <div className="practice-summary-card__title">
              {pendingPracticeUserQuiz?.id
                ? 'Continue your current practice session'
                : practiceSummary?.readyCount
                ? `You have ${practiceSummary.readyCount} practice questions ready`
                : 'No practice due right now'}
            </div>
            <div className="practice-summary-card__meta">
              {practiceSummary?.dueCount
                ? `${practiceSummary.dueCount} due now`
                : 'No due questions at the moment'}
              {practiceSummary?.estimatedMinutes
                ? ` · ${practiceSummary.estimatedMinutes} min`
                : ''}
              {!practiceSummary?.readyCount && practiceSummary?.nextReviewAt ? (
                <>
                  {' · Next review '}
                  <Moment format="MMM DD, YYYY">
                    {practiceSummary.nextReviewAt}
                  </Moment>
                </>
              ) : null}
            </div>
          </div>

          {pendingPracticeUserQuiz?.id ? (
            <Button
              variant="primary"
              onClick={() =>
                onResumePractice(pendingPracticeUserQuiz.id, pendingPracticeUserQuiz.quizId)
              }
            >
              Continue Practice
            </Button>
          ) : practiceSummary?.cta === 'start' && practiceSummary?.sourceUserQuizId ? (
            <Button
              variant="primary"
              onClick={() =>
                onStartPractice({
                  id: practiceSummary.practiceQuizId,
                  sourceUserQuizId: practiceSummary.sourceUserQuizId,
                  title: practiceSummary.practiceTitle || 'Practice',
                })
              }
            >
              Start Practice
            </Button>
          ) : null}
        </div>

        {/*
          {(pendingDiagnosticPackageIds?.length || pendingPracticeUserQuiz?.id) ? (
            <div className="diagnostic-bubble" aria-label="You have unfinished items">
              <span className="diagnostic-bubble__icon">
                <FaBell size={20} />
              </span>
              <div className="diagnostic-bubble__menu">
                {pendingDiagnosticPackageIds?.length ? (
                  <div className="diagnostic-bubble__menu-section">
                    <div className="diagnostic-bubble__menu-title">Diagnostic</div>
                    {pendingDiagnosticPackageIds.map((id) => (
                      <button
                        key={id}
                        type="button"
                        className="diagnostic-bubble__menu-item"
                        onClick={() => onClickCourse(id)}
                      >
                        Continue unfinished Diagnostic
                      </button>
                    ))}
                  </div>
                ) : null}

                {pendingPracticeUserQuiz?.id ? (
                  <div className="diagnostic-bubble__menu-section">
                    <div className="diagnostic-bubble__menu-title">Practice</div>
                    <button
                      type="button"
                      className="diagnostic-bubble__menu-item"
                      onClick={() =>
                        onResumePractice(pendingPracticeUserQuiz.id, pendingPracticeUserQuiz.quizId)
                      }
                    >
                      Continue practice
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        */}

        <div className={'courses-table'}>
          {(activeTab === 'courses'
            ? myCourses
            : activeTab === 'diagnostic'
            ? diagnosticCourses
            : (pendingPracticeUserQuiz?.id ? [pendingPracticeUserQuiz] : practiceQuizzes)
          )?.length == 0 ? (
            <div className="text-center p-5 emptyCart">
              {/* <img src={Images.cartEmpty} alt="" className="img-fluid mb-4" /> */}
              {activeTab === 'courses' ? (
                <>
                  <h4 className="heading-4">No Courses Found</h4>
                  <h5 className="heading-5 my-4">Purchase any course to view it</h5>
                  <a className="blue-button col" onClick={() => navigate('/courses')}>
                    Find a Course
                  </a>
                </>
              ) : activeTab === 'diagnostic' ? (
                <>
                  <h4 className="heading-4">No Diagnostic Packages Found</h4>
                  <h5 className="heading-5 my-4">
                    Your Diagnostic packages will appear here
                  </h5>
                </>
              ) : (
                <>
                  <h4 className="heading-4">No Practice Found</h4>
                  <h5 className="heading-5 my-4">Your practice tests will appear here</h5>
                </>
              )}
            </div>
          ) : (
            <div className="table-responsive myCoursesTable">
              <ReactTable
                columns={
                  activeTab === 'practice' ? practiceColumns : columns
                }
                data={
                  activeTab === 'courses'
                    ? tableData
                    : activeTab === 'diagnostic'
                    ? diagnosticTableData
                    : (pendingPracticeUserQuiz?.id
                      ? [
                          {
                            name: (
                              <div className="table-rows" key={pendingPracticeUserQuiz.quizId}>
                                <span className="active">
                                  {pendingPracticeUserQuiz?.quiz?.title || 'Practice'}
                                </span>
                              </div>
                            ),
                            createdAt: (
                              <div className="table-rows" key={pendingPracticeUserQuiz.id}>
                                <Moment format="MMM DD, YYYY">
                                  {pendingPracticeUserQuiz?.createdAt}
                                </Moment>
                              </div>
                            ),
                            action: (
                              <div className="table-rows" key={`${pendingPracticeUserQuiz.id}-a`}>
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() =>
                                    onResumePractice(
                                      pendingPracticeUserQuiz.id,
                                      pendingPracticeUserQuiz.quizId,
                                    )
                                  }
                                >
                                  Resume
                                </Button>
                              </div>
                            ),
                          },
                        ]
                      : practiceTableData)
                }
                pagination={true}
              />
            </div>
          )}
        </div>
      </div>
      <CustomFooter />
    </WithNavBar>
  );
}

export default MyCourses;
